import {
  Component,
  Inject,
  OnInit,
  AfterViewInit
} from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import * as Highcharts from 'highcharts/highstock';
import HC_exporting from 'highcharts/modules/exporting';
import HC_exportData from 'highcharts/modules/export-data';
import HC_fullscreen from 'highcharts/modules/full-screen';
import { Chart } from 'angular-highcharts';

// Load modules
HC_exporting(Highcharts);
HC_exportData(Highcharts);
HC_fullscreen(Highcharts);

@Component({
  selector: 'app-custom-bottom-sheet',
  templateUrl: './custom-bottom-sheet.component.html',
  styleUrls: ['./custom-bottom-sheet.component.scss']
})
export class CustomBottomSheetComponent implements OnInit, AfterViewInit {
  chartData: Chart | null = null;
  chartItemId: string = 'bottom-sheet-chart';

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<CustomBottomSheetComponent>
  ) {}

  ngOnInit(): void {
    this.loadChart();
  }

  ngAfterViewInit(): void {
    // Ensure chart is rendered after view is initialized
    setTimeout(() => {
      if (this.chartData?.ref) {
        this.chartData.ref.update({}, true);
      }
    }, 0);
  }

  loadChart(): void {
    try {
      const chartOptions = this.data.chartOptions;
      this.chartItemId = this.data.chartItemId || 'bottom-sheet-chart';

      // Add navigator and scrollbar if not already present
      chartOptions.navigator = chartOptions.navigator ?? { enabled: true };
      chartOptions.scrollbar = chartOptions.scrollbar ?? { enabled: true };
      chartOptions.rangeSelector = chartOptions.rangeSelector ?? { enabled: true };

      this.chartData = new Chart(chartOptions);
    } catch (error) {
      console.error('Error loading chart:', error);
    }
  }

  close(): void {
    this.bottomSheetRef.dismiss();
  }
}
